import { useState, useEffect } from "react";
import serverURL from "../../config/serverConfig";
import { useLocation } from "react-router-dom";
import { useClientProjects, deleteClient, updateClient } from "../../hooks/db";
import ProjectBlobClient from "../projects/ProjectBlobClient";
import { Link } from "react-router-dom";
import ClientIncome from "./ClientIncome";
import { Pen, Pencil, Save, X } from "lucide-react";
import { set } from "rsuite/esm/internals/utils/date";



export default function Client(props) {

    const location = useLocation(); 
    const client_id = location.state?.client_id || props.clientID;
    //const client_ID = Number(props.clientID);
    console.log(typeof(client_id))
    const [clientInfo, setClientInfo] = useState();
    const [tempClientInfo, setTempClientInfo] = useState();
    console.log(client_id)
    const clientProjects = useClientProjects(client_id);
    console.log("Client Projects: ", clientProjects);

    const [editing, setEditing] = useState(false);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteText, setDeleteText] = useState("");


    useEffect(() => {
        if (!client_id) return;

        fetch(`${serverURL}getClient`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ client_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setClientInfo(jsonData[0]);
                setTempClientInfo(jsonData[0]);
                console.log("Client info fetched:", jsonData);
            })
            .catch(error => {
                console.error("Error fetching projects:", error);
            });

    }, []);

    const handleSave = (e) => {
        // Implement save functionality here, e.g., send updated client info to the server
        console.log("Saving client info:", tempClientInfo);
        updateClient(tempClientInfo);
        setClientInfo(tempClientInfo);
        setEditing(false);
        
    }

    const handleCancel = (e) => {
        // Implement cancel functionality here, e.g., reset client info to original state
        console.log("Canceling edit");
        setTempClientInfo(clientInfo);
        setEditing(false);
    }
    
    const handleDeleteClick = () => {
        setShowDeleteConfirm(true);
    };
    const handleDeleteConfirm = () => {
        if (deleteText !== "DELETE") return;

        deleteClient(client_id);

        window.location.href = "/clients";
    };



    return (
        <div id="clientPage" className="max-w-[1500px] flex m-auto px-8">
            {clientInfo ? (

                <div className="p-6 flex flex-col m-aut w-full">
                    <div className="flex flex-row justify-between">
                        {!editing ? 
                        <h2 className="text-xl uppercase tracking-wider">{clientInfo.name}</h2>
                        :
                        <input type="text" className="mb-2 bg-[#444] text-xl uppercase tracking-wider rounded-md" value={tempClientInfo.name} onChange={(e) => setTempClientInfo({...tempClientInfo, name: e.target.value})} />
                        }
                        <div className="">
                            {!editing ? 
                                <Pen size={12} className="inline mb-1 mr-1 cursor-pointer" onClick={() => {setEditing(!editing)}}/>
                                :
                                <div>
                                    <Save size={18} className="inline mb-1 mr-1 cursor-pointer text-green-500" onClick={() => {handleSave()}}/>
                                    <X size={18} className="inline mb-1 cursor-pointer text-red-500" onClick={() => {handleCancel()}}/>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2 mt-2 py-5 px-3 rounded-2xl bg-[#181818] text-sm">
                        {!editing ? 
                            <>
                                
                                    <p><strong>Email:</strong> {clientInfo.email}</p>
                                    <p><strong>Phone:</strong> {clientInfo.phone}</p>
                                    {/* <p><strong>Address:</strong> {clientInfo.address}</p>
                                    <p><strong>Notes:</strong> {clientInfo.notes}</p> */}
                                
                            </>
                            
                        : 
                            <>
                                <p><strong>Email:</strong> <input type="text" className="mb-2 bg-[#222]" value={tempClientInfo.email} onChange={(e) => setTempClientInfo({...tempClientInfo, email: e.target.value})} /></p>
                                <p><strong>Phone:</strong> <input type="text" className="mb-2 bg-[#222]" value={tempClientInfo.phone} onChange={(e) => setTempClientInfo({...tempClientInfo, phone: e.target.value})} /></p>
                                {/* <p><strong>Address:</strong> <input type="text" className="mb-2 bg-[#222]" value={tempClientInfo.address} onChange={(e) => setTempClientInfo({...tempClientInfo, address: e.target.value})} /></p>
                                <p><strong>Notes:</strong> <input type="text" className="mb-2 bg-[#222]" value={tempClientInfo.notes} onChange={(e) => setTempClientInfo({...tempClientInfo, notes: e.target.value})} /></p> */}
                            </>
                        }
                    </div>
                    

                    {clientProjects && clientProjects.length > 0 ? (
                        <div className="flex flex-col gap-4 m-auto md:flex-row">
                            <div id="left" className="">
                                <div id="active_projects" className="gradientBG mt-6 p-3 pt-2 max-w-[600px]">
                                    <h4 className="uppercase text-sm">Active Projects</h4>
                                    <div className="hBar mt-[7px] mb-[10px]"></div>
                                    <div>
                                        <div>
                                            {clientProjects.map(project => (
                                                <Link 
                                                    to="/project"
                                                    state={{ project_id: project.project_id }}
                                                    key={project.project_id} 
                                                    className="py-2 border-b border-[#333]"
                                                >
                                                    {/* <strong>{project.title}</strong> - Due: {new Date(project.due_date).toLocaleDateString()} - Status: {project.status} */}
                                                    <ProjectBlobClient project={project} />
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="right">
                                <div id="clientIncomeHistory" className="gradientBG mt-6 p-3 pt-2  min-w-[300px] max-w-[400px]">
                                {/* <div id="clientIncomeHistory" className=""> */}
                                    <ClientIncome clientProjects={clientProjects} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p>No projects found for this client.</p>
                    )}
                    <div className="absolute right-1 bottom-1">
                        <button className="mt-6 px-2 py-1 bg-black text-xs text-red-500 rounded hoverUp hover:bg-[#161616]" onClick={handleDeleteClick}>Delete Client</button>
                    </div>
                    {showDeleteConfirm && (
                        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                            <div className="bg-[#1a1a1a] p-6 rounded-xl shadow-xl w-80 text-center">
                            <p className="text-red-500 font-semibold mb-4">
                                Type “DELETE” to permanently remove this client,
                                all associated projects, income history, and media.
                            </p>

                            <input
                                type="text"
                                value={deleteText}
                                onChange={(e) => setDeleteText(e.target.value)}
                                placeholder="Type DELETE"
                                className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white mb-4"
                            />

                            <div className="flex justify-between">
                                <button
                                onClick={() => {
                                    setShowDeleteConfirm(false)
                                    setDeleteText("")
                                }}
                                className="px-3 py-1 bg-gray-700 rounded hover:bg-gray-600"
                                >
                                Cancel
                                </button>

                                <button
                                onClick={handleDeleteConfirm}
                                disabled={deleteText !== "DELETE"}
                                className={`px-3 py-1 rounded border ${
                                    deleteText === "DELETE"
                                    ? "bg-red-600 hover:bg-red-700"
                                    : "bg-red-900 opacity-50 cursor-not-allowed"
                                }`}
                                >
                                Delete
                                </button>
                            </div>
                            </div>
                        </div>
                    )}
  

                </div>

            ) : (
                <p>Loading client information...</p>
            )}
        </div>
    )
}